import React, { PureComponent } from 'react';
import { isURL } from 'validator';
import { Label, Input, FormGroup, InputGroup, Col } from 'reactstrap';
import { string, func } from 'prop-types';

class FlowPostbackUrl extends PureComponent {
    static propTypes = {
        url: string.isRequired,
        onUrlChange: func.isRequired,
        onCheckPostback: func.isRequired,
    };

    isValidUrl = url => isURL(url);

    render() {
        const { url, onUrlChange, onCheckPostback } = this.props;

        return (
            <FormGroup className='postback-url-input'>
                <Col lg='4' md='4' sm='12'>
                    <Label for="postback-url">URL</Label>
                </Col>
                <Col lg='8' md='8' sm='12'>
                    <InputGroup>
                        <Input
                            type="url"
                            name="url"
                            id="postback-url"
                            onChange={({ target }) => {
                                onUrlChange({ [target.name]: target.value });
                            }}
                            value={url}
                            placeholder="http://example.com/"
                        />
                    </InputGroup>
                </Col>
            </FormGroup>
        );
    }
}

export default FlowPostbackUrl;
